import React from 'react';

export const XPToast = ({ show, amount }: { show: boolean, amount: number }) => {
    if (!show) return null;
    return (
        <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[200] animate-bounce-up pointer-events-none">
            <div className="text-fluid-4xl font-black text-yellow-400 drop-shadow-[2px_2px_0_rgba(0,0,0,1)] stroke-black">
                XP +{amount}!
            </div>
        </div>
    );
};
